import React, { type FC } from 'react';

import classNames from 'classnames';
import { motion } from 'framer-motion';
import styles from './CollapsibleContainer.module.scss';

type CollapsibleContainerProps = {
    isExpanded: boolean;
    className?: string;
};

const CollapsibleContainer: FC<CollapsibleContainerProps> = ({
    children,
    isExpanded,
    className,
}) => {
    return (
        <motion.div
            initial={{ height: isExpanded ? 'auto' : 0 }}
            exit={{ height: 0, opacity: 0 }}
            animate={{
                height: isExpanded ? 'auto' : 0,
                opacity: isExpanded ? 1 : 0,
            }}
            transition={{
                duration: 0.5,
                ease: 'easeInOut',
            }}
            className={classNames(styles.collapsibleContainer, className)}
        >
            {children}
        </motion.div>
    );
};

export default CollapsibleContainer;
